<template>
  <div class="folder_ty1 clear krs009">
    <div class="folder_nav">
      <div class="folder_list">
        <ul class="depth1">
          <li v-for="(categoryPaper, index) in categoryPaperList" :key="index" :class="categoryPaper.category.category.categoryMid === selectedCategoryMid ? 'active' : ''">
            <div class="tooltip-b tl small" :id="categoryPaper.category.category.categoryMid+'_per_tooltip'"
              :style="displayTooltip(categoryPaper)"  
            >
              {{ categoryPaper.category.category.categoryName }}
            </div>
            <button type="button" @click="selectCategory($event, categoryPaper)"
              @mouseover="categoryPaper.showTooltip = true"
              @mouseleave="categoryPaper.showTooltip = false"
            >
              <span class="ell-singleline">
                {{ categoryPaper.category.category.categoryName }}
              </span>
            </button>
            <!-- <dl class="more_box small">
              <dt><button type="button" class="more" @click="$event.target.parentElement.classList.toggle('active');">더보기</button></dt>
              <dd style="width: 80px;">
                <ul>
                  <li><button type="button" @click="updateFolderName(categoryPaper.category)">명 변경</button></li>
                  <li><button type="button" @click="deleteFolder(categoryPaper.category)"> 삭제</button></li>
                </ul>
              </dd>
            </dl> -->
            <ul class="depth2">
              <li v-for="(paper, index) in categoryPaper.paperList" :key="index">
                <button type="button"
                  v-show="paper.paperId.startsWith('_ALL_')"
                  @click="selectBoard('ALL', categoryPaper)"
                  :class="paper.paperId === selectedPaperId ? 'active' : ''"
                >
                  <span class="ell-singleline">{{ allPapersName }}</span><!-- ({{ paper.fileCount }}) -->
                </button>
                <!-- <div class="tooltip-b tl small"
                  v-show="paper.paperId.startsWith('_ALL_')"
                >
                  {{ allPapersName }}
                </div> -->
                <button type="button" 
                  v-show="!paper.paperId.startsWith('_ALL_')" 
                  @click="selectBoard('BOARD', paper)"
                  :class="paper.paperId === selectedPaperId ? 'active' : ''"
                >
                  <span class="ell-singleline">{{ paper.paperTitle }}</span><!-- ({{ paper.fileCount }}) -->
                </button>
                <div class="tooltip-b tl small"
                  v-show="!paper.paperId.startsWith('_ALL_') &&
                          checkTabLength(paper.paperTitle)"
                >
                  {{ paper.paperTitle }}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="folder_cnt">
      <div class="cnt_tit">{{ selectedPaperTitle }}</div>

      <div class="tb-list_ty1">
        <div class="tb-header clear">
          <div class="tb_num fl">
            <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalBoardFileCount})"></div>
            <!-- 검색 조회시 노출 S -->
            <div class="check_result other-bg-1" v-if="show">
              <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: searchResult, cnt: totalBoardFileCount})"></div>
              <button type="button" @click="resetFileList">초기화</button>
            </div>
            <!-- //검색 조회시 노출 E -->
          </div>

          <div class="tb_sort fr">
            <div class="search_ty2">
              <button type="button" class="search-show" :class="isOpenSearch ? 'active' : ''" @click="isOpenSearch = true">검색</button>
              <form action="" onsubmit="return false;" class="search-show">
                <div class="input-box">
                  <input type="text"
                    class="search-show"
                    :class="searchKeyword == '' ? 'ico_search' : ''"
                    v-model="searchKeyword"
                    :placeholder="$i18nUtil.trans('message.placeholder.fileName','파일명 검색')"
                    @keyup.enter="searchFileList(true)"
                    @focus="$event.target.placeholder = ''"
                    @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.fileName','파일명 검색')"
                    maxlength="21"
                  >
                  <!-- <button type="button" class="input-txt-del" @click="searchFileList($event)">입력 삭제</button> -->
                  <button type="reset" 
                    class="input-txt-del search-show" 
                    v-if="searchKeyword != ''"
                    @click="searchKeyword = ''" 
                  >
                    입력 삭제
                  </button>
                  <button type="reset" 
                    class="btn_search search-show" 
                    @click="searchFileList(true)"
                  >
                    검색
                  </button>
                </div>
              </form>
            </div>
            <BoardFileFilterBox
              ref="boardFileFilterBox"
              :extList="extList"
              :initFilter="initFilter"
              @applyFilter="applyFilter"
            />
              <!-- ref="boardFileFilterBox" -->
              <!-- :checkCount="checkCount"
              :checkFileLocations="checkFileLocations"
              :checkFileExts="checkFileExts" -->
            <div v-show="selected.length > 0" class="dividing_line_ty1"></div>
            <button v-show="selected.length > 0" type="button" class="btn-primary-small black" @click="downloadCheckedFile">{{ $i18nUtil.trans("button.file.download", "다운로드") }}</button>
          </div>
        </div><!-- //tb-header -->

        <v-data-table
        v-model="selected"
        :headers="headers"
        :items="fileList"
        :single-select="singleSelect"
        show-select
        :must-sort="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :server-items-length="totalBoardFileCount"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents">

        <template v-slot:[`item.fileName`]="{ item }">
          <div class="subject large" 
            :class="
              item.fileExtDesc === 'ppt' ? 'ico-file-ppt' :
              item.fileExtDesc === 'word' ? 'ico-file-word' :
              item.fileExtDesc === 'excel' ? 'ico-file-xlsx' :
              item.fileExtDesc === 'pdf' ? 'ico-file-pdf' :
              item.fileExtDesc === 'jpg' ? 'ico-file-jpg' :
              item.fileExtDesc === 'gif' ? 'ico-file-gif' :
              item.fileExtDesc === 'png' ? 'ico-file-png' :
              item.fileExt === 'tif' ? 'ico-file-tif' :
              item.fileExt === 'tiff' ? 'ico-file-tiff' :
              item.fileExt === 'bmp' ? 'ico-file-bmp' :
              item.fileExt === 'zip' ? 'ico-file-zip' :
              item.fileExt === 'hwp' ? 'ico-file-hwp' :
              'ico-file-etc'
            "
          >
            <button type="button" class="ell-singleline" @click="openFileViewer(item)">{{ item.fileName }}</button>
            <div class="file-lock board-filelist " :style="fileLockYn && selectedFileId == item.id ? '':'display:none;'"></div>
          </div>
        </template>

        <template v-slot:[`item.lastModDate`]="{ item }">
          <div v-if="isToday(item.lastModDate)">
            <momentAgo prefix="" suffix="전" :date="item.lastModDate" lang="kr"></momentAgo><!-- <span class="ico-new"></span> -->
          </div>
          <div v-if="!isToday(item.lastModDate)">
            {{ $moment(item.lastModDate).format('YYYY.MM.DD') }}
          </div>
        </template>

        <template v-slot:[`item.lastModUserName`]="{ item }">
          <div class="droplayer tooltipmember relative right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastModUserName: item.lastModUserNameEn != null ? item.lastModUserNameEn : item.lastModUserName }}</b>
                </v-btn>
              </template>
              <div class="dropdown-list">
                <UserTooltip
                  :userId="item.lastModUserId"
                />
              </div>
            </v-menu>
          </div>
        </template>

        <template v-slot:[`item.more`]="{ item }">
          <div class="droplayer icon more right nosel">
            <v-menu bottom left @input="onMenuToggle">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="checkStatus(attrs, item)">더보기</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="dropdown-list-item"><div class="tit"><button type="button" @click="downloadSelectedFile(item)">{{ $i18nUtil.trans("button.file.download", "다운로드") }}</button></div></div>
                <div class="dropdown-list-item"><div class="tit"><button type="button" :disabled="fileBtnDisabledYn" @click="confirmDeleteFile(item)">{{ $i18nUtil.trans("button.file.delete", "파일 삭제") }}</button></div></div>
              </div>
            </v-menu>
          </div>
        </template>

        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="true" v-if="!show" v-html="$i18nUtil.trans('message.ProjectFileList.001','등록된 파일이 없습니다.<br>과제 보드에 파일을 추가하여 관리해보세요.')">
              <!-- 등록된 파일이 없습니다.<br>{{$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드")}}에 파일을 추가하여 관리해보세요. -->
            </v-alert>
            <v-alert :value="true" v-if="show">
              {{ $i18nUtil.trans("search.007", "조회된 결과가 없습니다.") }} <!-- 조회된 결과가 없습니다. -->
            </v-alert>
          </div>
        </template>
        </v-data-table>

        <div class="pagination">
          <v-pagination
            v-model="page"
            circle
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </div>
      </div><!-- //tb-list_ty1 -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import BoardFileFilterBox from "@/components/cowork/general/filter/BoardFileFilterBox";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
//import RegistCategoryModal from "../../../modal/RegistCategoryModal";
export default {
  components: {
    BoardFileFilterBox,
    UserTooltip
  },
  data() {
    return {
      browser: null,
      singleSelect: false,
      groupId: '',
      groupKbn: 'PRO',
      totalBoardFileCount: 0,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.file.filter.fileName","파일명"), align: 'center', value: 'fileName', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdate","마지막 업데이트"), value: 'lastModDate', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdUserName","생성/수정자"), value: 'lastModUserName', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.more","더보기"), value: 'more', sortable: false },
      ],
      paperInfoList: [],
      categoryPaperList: [],
      fileList: [],
      allPapersName: this.$i18nUtil.trans("entity.file.allPapersName","전체"),
      selectedCategoryMid: '',
      selectedPaperId: '',
      selectedPaperTitle: '',
      zipFileName: '',
      /* 필터 관련 */
      extCheckYn:false,
      locationCheckYn:false,
      initFilter:[],
      extList : [
        { name : 'PPT', value : 'ppt' },
        { name : 'EXCEL', value : 'excel' },
        { name : 'WORD', value : 'word' },
        { name : 'HWP', value: 'hwp' },
        { name : 'PDF', value : 'pdf' },
        { name : 'IMG', value : 'img' },
        { name : 'ZIP', value : 'zip' },
        { name : 'ETC', value : 'etc' }
      ], // 파일 유형 목록
      /* userList: [], */ // 생성/수정자 목록
      checkCount: 0, // 체크한 필터 수
      checkFileLocations: [], // 체크한 파일 경로 목록
      checkFileExts: [], // 체크한 파일 유형 목록
      /* checkFileEditors: [], */ // 체크한 생성/수정자 목록
      /* 페이징 관련 */
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      /* 검색 관련 */
      show: false,
      isOpenSearch: false,
      searchKeyword: '',
      searchResult: '',
      /* 정렬 관련 */
      sortBy: 'lastModDate',
      sortDesc: true,
      changeTableData: false,
      /* 토스트 알림 */
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko',

      fileBtnDisabledYn : true,
      fileLockYn: false,
      selectedFileId:''
    };
  },
  watch: {
    page: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
        window.scrollTo(0, 0);
      }
    },
    sortBy: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    sortDesc: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true) {
          setTimeout(() => {
            obj.changeTableData = false;
            obj.selected = [];
            obj.getBoardFileList();
          }, 500);
        }
      },
      deep: true
    }
  },
  created() {
    this.browser = this.$tooltip.checkBrowser();
  },
  mounted() {
    const self = this;
    $("html").click(function (e) {
      if(!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
        self.isOpenSearch = false;
      }
    });
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_ACTION","COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),

    /* 툴팁 */
    displayTooltip(categoryPaper) {
      if(this.$tooltip.checkTabLength(categoryPaper.category.category.categoryName, 20) && categoryPaper.showTooltip) {
        return 'display:block;';
      }else{
        return 'display:none;';
      }
    },
    /* GroupId 세팅 */
    setgroupId(groupId, state) {
      let obj = this;
      obj.groupId = groupId;
      obj.moreMenuClose();
      if(window.sessionStorage.getItem("moveBoard") === 'true'){
        // window.sessionStorage.setItem("moveBoard",false);
      }else{ 
        let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
        if(stateArr.length == 0){
          //저장
          stateArr.push(state);
          window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
        }else{
          let lastState = stateArr[stateArr.length-1];
          if(lastState.currentTab == 1 && lastState.currentTab2 == 0 && lastState.currentTab3 == 1){
            // 같은 탭 누른 경우 .
          }else{
            // 다른 탭에서 누른경우
            stateArr.push(state);
            window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
          }
        } 
        if(window.sessionStorage.getItem("prevBtn")  === 'true' ){ 
          // 뒤로가기 버튼으로 접근.
          // window.sessionStorage.setItem("prevBtn",false); 
        }else{ 
        }
      }
      obj.getGroupCategoryPaperList();
    },
    /* 보드 목록 조회 */
    getGroupCategoryPaperList() {
      let obj = this;
      let reqData = {
        url: '/api/copaper/paper/getGroupCategoryPaperList',
        method: 'post',
        req: { groupId : obj.groupId }
      };
      
       //뒤로가기로 접근시 데이터 set
      if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
        window.sessionStorage.setItem("moveBoard",false);
        window.sessionStorage.setItem("prevBtn",false);
        let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
        let state = stateArr[stateArr.length-1];

        //검색 설정 
        if(state.searchKeyword != ""){
          this.isOpenSearch =true;
          this.show = true;
          this.searchKeyword = state.searchKeyword;
          this.searchResult = state.searchKeyword;
        }
        //페이지 설정 
        obj.page = state.page;

        // 테이블 정렬 설정 
        obj.sortBy = state.sortBy;
        obj.sortDesc = state.sortDesc;
        //필터 유지.           

        obj.selectedCategoryMid = state.selectedCategoryMid;
        obj.selectedPaperId = state.selectedPaperId;
        obj.selectedPaperTitle = state.selectedPaperTitle;
        obj.zipFileName = state.zipFileName;

        obj.checkFileLocations = state.checkFileLocations;
        obj.checkFileExts = state.checkFileExts;

        obj.initFilter = {
          checkFileLocations : state.locationCheckYn == true ? state.checkFileLocations : [],
          checkFileExts :state.extCheckYn == true ? state.checkFileExts : [],
        }
      }else {
        obj.page = 1;
        obj.searchKeyword = '';
        obj.searchResult = '';
        obj.sortBy = 'lastModDate';
        obj.sortDesc = true;
        obj.isOpenSearch = false;
        obj.selectedCategoryMid = '';
        obj.selectedPaperId = '';
        obj.selectedPaperTitle = '';
        obj.zipFileName = '';
        obj.show = false;

        /* 필터 초기화 */
        obj.checkCount = 0;
        obj.checkFileLocations = [];
        obj.checkFileExts = [];
        obj.$refs.boardFileFilterBox.prevModelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.prevModelExtCodeList = [];
        obj.$refs.boardFileFilterBox.modelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.modelExtCodeList = [];
      }


      obj.selected = [];

      // obj.$refs.boardFileFilterBox.show = false;
      // obj.$refs.boardFileFilterBox.apply = false;
      // obj.$refs.boardFileFilterBox.checkFilterCount = 0;
      // obj.$refs.boardFileFilterBox.prevModelFileLocationCodeList = [];
      // obj.$refs.boardFileFilterBox.checkFileExtsFilter = [];

      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            let categoryPaperList = res.result;
            let selectedCategoryMid = obj.selectedCategoryMid;
            let selectedPaperId = obj.selectedPaperId;
            let selectedPaperTitle = obj.selectedPaperTitle;
            let zipFileName = obj.zipFileName;

            if(categoryPaperList.length > 0) {
              /* 2021.02.09 API에서 이름순으로 정렬해서 내려주기 때문에 주석 처리 */
              //for(let idx=0; idx<categoryPaperList.length; idx++) { // 보드명 이름순 정렬 처리 
              //  let paperList = categoryPaperList[idx].paperList.sort((prevObj, newObj) => {
              //    var prevPaperTitle = prevObj.paperTitle;
              //    var newPaperTitle = newObj.paperTitle;
              //    if(prevPaperTitle < newPaperTitle) {
              //      return -1;
              //    } else if(prevPaperTitle > newPaperTitle) {
              //      return 1;
              //    } else {
              //      return 0;
              //    }
              //  });
              //}

              // 링크된 보드 배열에서 제외
              for(let i=0; i<categoryPaperList.length; i++) {
                let paperList = categoryPaperList[i].paperList;
                for(let j=0; j<paperList.length; j++) {
                  if(paperList[j].kbn == 'LINK_PROJECT') {
                    paperList.splice(j, 1);
                    j--;
                  }else {
                    categoryPaperList[i].showTooltip = false;
                  }
                }
              }

              obj.categoryPaperList = categoryPaperList;
              obj.selectedCategoryMid = selectedCategoryMid === '' ? categoryPaperList[0].category.category.categoryMid : selectedCategoryMid;
              obj.selectedPaperTitle = selectedPaperTitle === '' ? obj.allPapersName : selectedPaperTitle;
              obj.zipFileName = zipFileName === '' ? categoryPaperList[0].category.category.categoryName : zipFileName;
              if(selectedPaperId === '') {
                let paperId = categoryPaperList[0].paperList[0].paperId;

                obj.paperInfoList = [];
                if(paperId.startsWith('_ALL_')) {
                  for(let i=0; i<categoryPaperList[0].paperList.length; i++) {
                    if(!categoryPaperList[0].paperList[i].paperId.startsWith('_ALL_')) {
                      let paperInfo = {};

                      paperInfo.kbn = categoryPaperList[0].paperList[i].kbn;
                      paperInfo.paperId = categoryPaperList[0].paperList[i].paperId;
                      paperInfo.categoryMid = categoryPaperList[0].paperList[i].categoryMid;
                      paperInfo.categoryName = categoryPaperList[0].paperList[i].categoryName;

                      obj.paperInfoList.push(paperInfo);
                    }
                  }
                } else {
                  let paperInfo = {};

                  paperInfo.kbn = categoryPaperList[0].paperList[0].kbn;
                  paperInfo.paperId = categoryPaperList[0].paperList[0].paperId;
                  paperInfo.categoryMid = categoryPaperList[0].paperList[0].categoryMid;
                  paperInfo.categoryName = categoryPaperList[0].paperList[0].categoryName;

                  obj.paperInfoList.push(paperInfo);
                }
                
                obj.getBoardFileList();
                obj.selectedPaperId = paperId;
              } else {
                obj.getBoardFileList();
              }
            }
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    /* 보드 파일 목록 조회 */
    getBoardFileList() {
      let obj = this;
      let reqData = {
        url: '/api/cofile/cofile/getBoardFileList',
        method: 'post',
        req: {
          groupId : obj.groupId,
          paperInfoList : obj.paperInfoList,
          searchKeyword : obj.searchKeyword,
          page : obj.page - 1, // 현재 페이지
          itemsPerPage : obj.itemsPerPage, // 페이지당 파일 수
          sortBy : obj.sortBy, // 정렬기준 (fileName, lastModDate, lastModUserName)
          sortDesc : obj.sortDesc, // 정렬순서 (true: 내림차순, false: 오름차순)
          fileLocationFilter: obj.checkFileLocations, // 체크한 파일 경로 목록
          fileExtFilter: obj.checkFileExts, // 체크한 파일 유형 목록
        }
      };

      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.totalBoardFileCount = res.result.totalBoardFileCount;
            obj.pageCount = res.result.totalPageCount;
            obj.fileList = res.result.fileList;
            /* obj.userList = res.result.userList; */
            obj.searchResult = res.result.searchKeyword;
            obj.searchKeyword = res.result.searchKeyword;
            obj.show = obj.searchResult != '' ? true : false;

            // sessionStorage에 저장. 
              let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
              if(sessionState.length != 0){
                let lastState = sessionState.pop();
                lastState.checkFileExts = obj.checkFileExts;
                lastState.checkFileLocations = obj.checkFileLocations;
                lastState.sortBy = obj.sortBy;
                lastState.sortDesc =  obj.sortDesc; 
                lastState.page = obj.page;
                lastState.searchKeyword =  obj.searchKeyword; 
                lastState.selectedCategoryMid =  obj.selectedCategoryMid; 
                lastState.selectedPaperId =  obj.selectedPaperId; 
                lastState.selectedPaperTitle =  obj.selectedPaperTitle; 
                lastState.zipFileName =  obj.zipFileName;  
                lastState.extCheckYn = obj.extCheckYn;
                lastState.locationCheckYn = obj.locationCheckYn;
                sessionState.push(lastState);
                window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
              }

          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    /* 필터 적용 */
    applyFilter(_data) {
      let obj = this;
      // obj.checkCount = _data.checkFilterCount;
      obj.checkFileLocations = _data.checkFileLocationsFilter;
      obj.checkFileExts = _data.checkFileExtsFilter;
      obj.extCheckYn = _data.extCheckYn;
      obj.locationCheckYn = _data.locationCheckYn;
      obj.page = 1;
      obj.selected = []; // 체크된 파일 체크 해제

      // 파일 목록 API 호출
      obj.getBoardFileList();
    },
    /* 선택 */
    selectCategory(e, param) {
      let obj = this;
      let selectedCategoryMid = obj.selectedCategoryMid;
      let categoryMid = param.category.category.categoryMid;
      obj.paperInfoList = [];

      if(selectedCategoryMid == categoryMid) {
        obj.selectedCategoryMid = '';
      } else {
        let categoryName = param.category.category.categoryName;
        let paperList = param.paperList;

        for(let i=0; i<paperList.length; i++) {
          if(paperList[i].paperId.startsWith('_ALL_')) {
            obj.selectedPaperId = paperList[i].paperId;
          } else {
            let paperInfo = {};

            paperInfo.kbn = paperList[i].kbn;
            paperInfo.paperId = paperList[i].paperId;
            paperInfo.categoryMid = paperList[i].categoryMid;
            paperInfo.categoryName = paperList[i].categoryName;

            obj.paperInfoList.push(paperInfo);
          }
        }

        obj.selected = [];
        obj.page = 1;
        obj.show = false;
        obj.isOpenSearch = false;
        obj.searchKeyword = '';
        obj.searchResult = '';
        obj.selectedPaperTitle = obj.allPapersName;
        obj.zipFileName = categoryName;
        obj.selectedCategoryMid = categoryMid;

        /* 필터 초기화 */
        obj.checkCount = 0;
        obj.checkFileLocations = [];
        obj.checkFileExts = [];
        obj.$refs.boardFileFilterBox.prevModelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.prevModelExtCodeList = [];
        obj.$refs.boardFileFilterBox.modelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.modelExtCodeList = [];

        obj.getBoardFileList();
      }
    },
    /* 보드 선택 */
    selectBoard(type, param) {
      let obj = this;
      obj.paperInfoList = [];

      if(type === 'ALL') {
        let categoryName = param.category.category.categoryName;
        let paperList = param.paperList;

        for(let i=0; i<paperList.length; i++) {
          if(paperList[i].paperId.startsWith('_ALL_')) {
            obj.selectedPaperId = paperList[i].paperId;
          } else {
            let paperInfo = {};

            paperInfo.kbn = paperList[i].kbn;
            paperInfo.paperId = paperList[i].paperId;
            paperInfo.categoryMid = paperList[i].categoryMid;
            paperInfo.categoryName = paperList[i].categoryName;

            obj.paperInfoList.push(paperInfo);
          }
        }
        
        obj.selectedPaperTitle = obj.allPapersName;
        obj.zipFileName = categoryName;
      } else {
        let paperInfo = {};
        
        paperInfo.kbn = param.kbn;
        paperInfo.paperId = param.paperId;
        paperInfo.categoryMid = param.categoryMid;
        paperInfo.categoryName = param.categoryName;

        obj.paperInfoList.push(paperInfo);
        obj.selectedPaperId = param.paperId;
        obj.selectedPaperTitle = param.paperTitle;
        obj.zipFileName = param.paperTitle;
      }

      // sessionStorage에 저장. 
      // let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
      // if(sessionState.length != 0){
      //   let lastState = sessionState.pop();
      //   lastState.categoryName = param.categoryName;
      //   lastState.categoryMid = param.categoryMid;
      //   lastState.paperId = param.paperId;
      //   lastState.paperTitle = param.paperTitle;
      //   lastState.type = type;
      //   lastState.param = param;
      //   lastState.kbn = param.kbn;
      //   sessionState.push(lastState);
      //   window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
      // }

      obj.selected = [];
      obj.page = 1;
      obj.show = false;
      obj.isOpenSearch = false;
      obj.searchKeyword = '';
      obj.searchResult = '';

      /* 필터 초기화 */
      obj.checkCount = 0;
      obj.checkFileLocations = [];
      obj.checkFileExts = [];
      obj.$refs.boardFileFilterBox.prevModelFileLocationCodeList = [];
      obj.$refs.boardFileFilterBox.prevModelExtCodeList = [];
      obj.$refs.boardFileFilterBox.modelFileLocationCodeList = [];
      obj.$refs.boardFileFilterBox.modelExtCodeList = [];

      obj.getBoardFileList();
    },
    /* 오늘 날짜 체크 */
    isToday(date) {
      let obj = this;
			let now = obj.$moment();
			let before24hours = obj.$moment().subtract(1, 'days');
			let lastUpdatedTime = obj.$moment(date);
			
			if(lastUpdatedTime.isBetween(before24hours, now)) {
				// 24시간 이내
				return true;
			} else {
				// 24시간 이후
				return false;
      }
    },
    /* 체크된 파일 다운로드 */
    downloadCheckedFile() {
      let obj = this;
      let selected = obj.selected;
      let fileName = '';
      let param = {};

      if(selected.length === 0) {
        // AlertModal - 파일을 선택해 주세요.
        obj.showAlertDialog(obj.$i18nUtil.trans("AB061", "파일을 선택해주세요."));
        return;
      } else if(selected.length > 1) { // 파일 멀티 다운로드
        // 프로그레스바 시작
        obj.showLoadingbar();

        let fileIds = [];
        for(let i=0; i<selected.length; i++) {
          fileIds.push(selected[i].id.toString());
        }

        param.groupId = obj.groupId;
        param.fileIds = fileIds;
        param.type = 'MULTI';
        param.groupKbn = obj.groupKbn;
        
        /*
         * 파일 멀티 다운로드 시 압축파일명 세팅
         *
         * 1. 전체 보드 파일 목록에서 다운로드 - 카테고리명.zip
         * 2. 개별 보드 파일 목록에서 다운로드 - 보드명.zip
         */
        fileName = obj.zipFileName + '.zip';
      } else { // 파일 개별 다운로드
        // 프로그레스바 시작
        obj.showLoadingbar();

        let fileId = selected[0].id.toString();
        
        param.groupId = obj.groupId;
        param.fileId = fileId;
        param.type = 'SINGLE';
        param.groupKbn = obj.groupKbn;

        fileName = selected[0].fileName;
      }

      obj.moreMenuClose();
      obj.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: param
      })
      .then(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        try {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let errorCode = obj.blobToString(blob);
            if(errorCode == "NOT_AUTHORIZED") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB044", "권한이 없습니다.");
              obj.showToast(obj.toastInfo);
              return;
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB101", "외부망에서는 파일 다운로드를 할 수 없습니다."));
              return;
            } else {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
              return;
            }
          }

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let link = document.createElement("a");
            link.target = "_self";
            link.setAttribute("download", fileName);
            link.href = window.URL.createObjectURL(blob);
            link.click();
            link.remove();
          }
        } catch (e) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
          console.error(e);
        }
      })
      .catch(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
        console.log(res);
      });
    },
    /* 선택한 파일 다운로드 */
    downloadSelectedFile(file) {
      let obj = this;
      let fileId = file.id.toString();
      let fileName = file.fileName;
      let param = {};

      param.groupId = obj.groupId;
      param.fileId = fileId;
      param.type = 'SINGLE';
      param.groupKbn = obj.groupKbn;
      
      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.moreMenuClose();
      obj.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: param
      })
      .then(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        try {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let errorCode = obj.blobToString(blob);
            if(errorCode == "NOT_AUTHORIZED") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB044", "권한이 없습니다.");
              obj.showToast(obj.toastInfo);
              return;
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB101", "외부망에서는 파일 다운로드를 할 수 없습니다."));
              return;
            } else {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
              return;
            }
          }

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let link = document.createElement("a");
            link.target = "_self";
            link.setAttribute("download", fileName);
            link.href = window.URL.createObjectURL(blob);
            link.click();
            link.remove();
          }
        } catch (e) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
          console.error(e);
        }
      })
      .catch(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        obj.showAlertDialog(obj.$i18nUtil.trans("AB077", "알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요."));
        console.log(res);
      });
    },
    /* 파일 삭제 모달 */
    confirmDeleteFile(file) {
      let obj = this;
      let fileId = file.id.toString();

      obj.moreMenuClose();
      // ConfirmModal - 파일을 삭제하시겠습니까?
      obj.showConfirmDialog(
        { width:"400px" },
        obj.$i18nUtil.trans("title.dialog.notice", "알림"),
        obj.$i18nUtil.trans("AB013", "파일을 삭제하시겠습니까?"),
        obj.$i18nUtil.trans("button.dialog.delete","삭제"),
        obj.deleteFile,
        { groupId: file.groupId, fileId: fileId },
        obj.$i18nUtil.trans("button.dialog.cancel","취소"),
        null,
        "deleteFile"
      );
    },
    /* 파일 삭제 */
    deleteFile(_data) {
      let obj = this;
      let reqData = {
        url: "/api/cofile/paper/deleteAttach",
        method: "post",
        req: {
          groupId: _data.modalParam.groupId,
          fileId: _data.modalParam.fileId,
        },
      };

      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.searchKeyword = obj.searchResult; // 검색 상태 유지
            obj.page = 1;
            obj.getBoardFileList();
            obj.toastInfo.message = obj.$i18nUtil.trans("TB011", "파일이 삭제되었습니다."); // 파일이 삭제되었습니다.
            obj.showToast(obj.toastInfo);
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
            if(res.errorMessage != null && res.errorMessage == "2700"){
              obj.fileBtnDisabledYn = true;
              obj.fileLockYn = true;
            }
          }
        })
        .catch(function(err) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          console.log(err);
        });
    },
    /* 검색창 오픈 */
    openSearch(e) {
      e.target.classList.toggle('active');

      // 검색창 오픈 시 input 포커싱 => input 포커싱되면 IE에서 placeholder가 안보여서 주석 처리
      //if(e.target.classList.contains('active')) {
      //  e.target.nextElementSibling.childNodes[0].focus();
      //}
    },
    /* 파일명 검색 */
    searchFileList(isOpenSearch) {
      let obj = this;

      if(isOpenSearch) {
        if(obj.searchKeyword == '') {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB091", "검색어를 입력해주세요.");
          obj.showToast(obj.toastInfo);
          return;
        }
      }

      obj.selected = [];
      obj.page = 1;
      obj.getBoardFileList();
    },
    /* 검색 조건 초기화 */
    resetFileList() {
      let obj = this;

      obj.selected = [];
      obj.page = 1;
      obj.searchKeyword = '';
      obj.getBoardFileList();
    },
    /* 더보기 메뉴 전체 닫기 */
    moreMenuClose() {
      let moreElement = this.$el.getElementsByClassName('more');
      for(let idx=0; idx<moreElement.length; idx++) {
        if(moreElement[idx].parentElement.classList.contains("active")) {
          moreElement[idx].parentElement.classList.remove("active");
        }
      }
    },
    /* 파일 뷰어 */
    openFileViewer(file) {
	  let hanwha = $(location).attr("origin");
		let groupId = file.groupId;
		if (groupId != null || groupId != "") {
			window.open(
				hanwha + "/general/viewer/" + groupId + "/" + file.id
			);
		}
    },
    /* blob To string */
    blobToString(blob) {
      let u, x;
      u = URL.createObjectURL(blob);
      x = new XMLHttpRequest();
      x.open('GET', u, false);
      x.send();
      URL.revokeObjectURL(u);
      return x.responseText;
    },
    checkTabLength(paperTitle) {
      let byteLength = 20;
      let checkBytes = this.getByteLength(paperTitle);
      if(checkBytes > byteLength) {
        return true;
      } else {
        return false;
      }
    },
    getByteLength(str) {
      if(str == null || str.length == 0) {
        return 0;
      }

      var size = 0;
      for(var i=0; i<str.length; i++) {
        size += this.charByteSize(str.charAt(i));
      }

      return size;
    },
    charByteSize(ch) {
      if(ch == null || ch.length == 0) {
        return 0;
      }

      var charCode = ch.charCodeAt(0);

      if (charCode <= 0x00007F) {
        return 1;
      } else if (charCode <= 0x0007FF) {
        return 2;
      } else if (charCode <= 0x00FFFF) {
        return 2;
      } else {
        return 2;
      }
    },
    // add: function() {
    //   this.list.push({ tit: "" + id, id: id++ });
    // },
    replace: function() {
      this.list = [{ tit: "", id: id++ }];
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    checkStatus(attrs, item){
      this.selectedFileId = item.id;
      if(attrs["aria-expanded"] == "false"){
        let obj = this;
        obj.fileBtnDisabledYn = true;
        obj.fileLockYn = false;
        let reqData = {
          url: "/api/cofile/paper/checkFileLock",
          method: "post",
          params : {
            fileId: item.id
            // paperBlockId: this.bdata.paperBlockId
          }
        };
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          if(res.errorCode != null) {
          } else {
            if(res.result.LockType){
              if(res.result.LockType != "" && res.result.LockType === "NONE"){
                obj.fileBtnDisabledYn = false;
                obj.fileLockYn = false;
              }else{
                obj.fileBtnDisabledYn = true;
                obj.fileLockYn = true;
              }
            } else{
              obj.fileBtnDisabledYn = false;
              obj.fileLockYn = false;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      }
    },
    onMenuToggle(opened){
      if(!opened){
        this.fileLockYn = false;
      }
    }
  }
}
</script>

<style scoped>
   .krs009 .folder_list .depth1 .tooltip-b {
      display: none;
      position: absolute;
      /* left: 0; */
      top: 42px;
      width: 200px;
      word-break: break-all;
      z-index: 10;
  }
  .krs009 .folder_list .depth2 .tooltip-b {
      top: 24px;
  }
  .krs009 .folder_list .depth1 li button span {position: relative;}
  /* .krs009 .folder_list .depth1 li button:hover .tooltip-b {display: block;} */
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/file/BoardFileList.vue